export class BdArrayUtil {
  public static move<T>(
    values: Array<T>,
    oldIndex: number,
    newIndex: number,
  ): Array<T> {
    if (newIndex >= values.length) {
      let k = newIndex - values.length + 1;
      while (k--) {
        values.push(undefined);
      }
    }
    values.splice(newIndex, 0, values.splice(oldIndex, 1)[0]);

    return values;
  }

  public static unique<T>(
    values: Array<T>,
    uniqueKeyFn: (value: T) => string | number,
  ): Array<T> {
    return [
      ...new Map<string | number, T>(
        values.map((item) => [uniqueKeyFn(item), item]),
      ).values(),
    ];
  }

  public static equals<T>(
    arrA: T[],
    arrB: T[],
    compareFnc?: (a: T, b: T) => boolean,
    sortFnc?: (a: T, b: T) => number,
  ): boolean {
    let result;

    if (!arrA && !arrB) {
      result = true;
    } else if (!arrA || !arrB) {
      result = false;
    } else {
      const arrASorted = sortFnc
        ? arrA.slice().sort(sortFnc)
        : arrA.slice().sort();
      const arrBSorted = sortFnc
        ? arrB.slice().sort(sortFnc)
        : arrB.slice().sort();

      result =
        arrASorted.length === arrBSorted.length &&
        arrASorted.every((value, index) => {
          let isEqual;
          if (compareFnc) {
            isEqual = compareFnc(value, arrBSorted[index]);
          } else {
            isEqual = value === arrBSorted[index];
          }

          return isEqual;
        });
    }

    return result;
  }

  public static average(arr: number[]): number | null {
    let result = null;

    if (!!arr && arr.length > 0) {
      result =
        arr.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0,
        ) / arr.length;
    }

    return result;
  }

  public static sum(arr: number[]): number | null {
    let result = null;

    if (!!arr && arr.length > 0) {
      result = arr.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        0,
      );
    }

    return result;
  }

  public static median(arr: number[]): number | null {
    return BdArrayUtil.quartile(arr, 0.5);
  }

  public static quartile(
    arr: number[],
    percent: 0.25 | 0.5 | 0.75,
  ): number | null {
    const result = null;

    if (!!arr && arr.length > 0) {
      arr.sort((a, b) => a - b);

      const pos = (arr.length - 1) * percent;
      const base = Math.floor(pos);
      const rest = pos - base;

      if (arr[base + 1] !== undefined) {
        return arr[base] + rest * (arr[base + 1] - arr[base]);
      } else {
        return arr[base];
      }
    }

    return result;
  }

  /**
   * Returns an array with arrays of the given size.
   */
  public static chunking<T>(array: Array<T>, chunkSize: number): T[][] {
    let index = 0;
    const arrayLength = array.length;
    const result: Array<Array<T>> = [];

    for (index = 0; index < arrayLength; index += chunkSize) {
      const chunk = array.slice(index, index + chunkSize);
      result.push(chunk);
    }

    return result;
  }
}
